import React, { useRef } from 'react';
import { get } from 'lodash';
import SVG from 'react-inlinesvg';
import { toAbsoluteUrl } from '../../_metronic/_helpers';

export function TextField({
  label,
  formik,
  field,
  type = 'text',
  labelClasses = '',
  containerClasses = '',
  inputSize = 410,
  labelMinSize = 80,
  labelMaxSize,
  disabled = false,
  id = '',
  password = false,
  ...rest
}) {
  const ref = useRef();
  const toggle = () => {
    if (ref.current.type === 'password') ref.current.type = 'text';
    else ref.current.type = 'password';
  };
  return (
    <div className={`form-group fv-plugins-icon-container ${containerClasses}`}>
      <div className="d-flex align-items-center">
        <label
          style={{ minWidth: labelMinSize, maxWidth: labelMaxSize }}
          className={labelClasses}
        >
          {label}
        </label>
        {password ? (
          <>
            <input
              autoComplete="on"
              id={id || field}
              disabled={disabled}
              type={type}
              {...rest}
              ref={ref}
              style={{ width: inputSize, paddingRight: 35 }}
              className={`form-control form-control-solid h-auto py-3 pl-4`}
              {...formik.getFieldProps(field)}
            />
            <div
              className="position-absolute cursor-pointer"
              style={{ right: 15, padding: 10 }}
              onClick={toggle}
            >
              <SVG
                src={toAbsoluteUrl('/media/svg/senseworks/view.svg')}
                uniquifyIDs
              />
            </div>
          </>
        ) : (
          <input
            autoComplete="on"
            id={id || field}
            disabled={disabled}
            type={type}
            {...rest}
            style={{ width: inputSize }}
            className={`form-control form-control-solid h-auto py-3 px-4`}
            {...formik.getFieldProps(field)}
          />
        )}
      </div>
      {(get(formik, `touched.${field}`, false) || field.includes('.')) &&
      get(formik, `errors.${field}`, false) ? (
        <div className="d-flex">
          <label style={{ minWidth: labelMinSize, maxWidth: labelMaxSize }}>
            {' '}
          </label>
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">
              {get(formik, `errors.${field}`, '')}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
